/** Whether dev-only settings tools (e.g. wipe user data) should be shown. */
export function isDevToolsEnabled(): boolean {
  if (import.meta.env.DEV) {
    return true;
  }

  return import.meta.env.VITE_DEV_TOOLS === 'true';
}
